import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from 'services/axios';

import { Endpoints, queryKeys } from '../constants';

// Update Pin api //
const updatePinApi = (payload: any) => {
  return useAPI({
    method: 'PATCH',
    url: `${Endpoints.CHANGE_PIN}`,
    data: payload,
  });
};

export const useUpdatePinApiQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(updatePinApi, {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.CHANGE_PIN]);
    },
  });
};
